import styled from 'styled-components';

export const DataIndexMenuEditModalContainer = styled.div`
    .table-container{
        border-radius: 8px;
        background-color: #33363C;
        padding: 10px 25px;
        // transition: width 0.2s ease-out;
    }
    .inputData_table_searchable .css-1tbggly {
        background-color: #33383c !important;
        // border: 1px solid #f5f5f54d !important;
        min-height: 4.5rem;
      }
      .inputData_table_searchable
        .css-78trlr-MuiButtonBase-root-MuiIconButton-root {
        color: #fff;
      }
      .dataIndex_table{
        min-height: 100px; 
      }
      .dataIndex_table .ant-spin-nested-loading{
        min-height: 100px;
      }
      .inputData_table_searchable tbody tr.MuiTableRow-root {
        background-color: #33383c !important;
      }
      .inputData_table_searchable .css-10gei56 {
        background-color: #33383c !important;
        min-height: 4.5rem;
      }
      .inputData_table_searchable {
        border: 1px solid #f5f5f54d !important;
        border-radius: 8px;
      }
      .dataIndex_table .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 {
        color: #fff;
        width: 100%;
        box-shadow: none;
        border: none;
        border-radius: 0px;
      }
      .inputData_table_searchable .MuiTablePagination-root .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-animated.MuiFormLabel-colorPrimary.MuiInputLabel-root.MuiInputLabel-animated {
        color: #fff;
        font-size: 14px;
      }
      .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary {
        color: #36BDBE;
        font-size: 14px;
      }
      .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary svg{
        color: #36BDBE !important;
        font-size: 22px;
      }
      .inputData_table_searchable .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {
        color: #36BDBE !important;
        font-size: 22px;
      }
      .dataIndex_table button.Mui-disabled[area-label="Clear search"] {
        background-color: transparent;
        // color: #ffffff !important;
      }
      .dataIndex_table button[area-label="Clear search"] {
        background-color: transparent;
        color: #ffffff !important;
        padding: 2px 2px;
      }
      .dataIndex_table button[area-label="Clear search"]:focus{
        border-radius: 0px;
      }
      .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd {
        color: #fff;
        padding: 0px 10px;
        background: rgba(255, 255, 255, 0.24);
      }
      .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd input{
        padding: 3px 0px;
        font-size: 14px;
        color: #ffffff;
      }
      .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd input::placeholder {
        color: #ffffff;
      }
      .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd fieldset{
        border: none;
      }
        .dataIndex_table svg[data-testid="SearchIcon"]{
        font-size: 20px;
}
      .panel_data_form .MuiOutlinedInput-root.Mui-disabled fieldset{
        border-color: gray;
      }
      .panel_data_form .MuiOutlinedInput-input.Mui-disabled{
        color: gray;
        -webkit-text-fill-color: gray;
      }
      .panel_data_form .MuiFormLabel-root.Mui-disabled{
        color: gray !important;
      }
      
      .inputData_table_searchable
        .MuiCollapse-wrapper.MuiCollapse-horizontal.css-18w3a48-MuiCollapse-wrapper {
        border: 1px solid #f5f5f54d !important;
        display: block !important;
        border-radius: 5px;
      }
      .inputData_table_searchable .MuiTableCell-head svg[data-testid="SyncAltIcon"] {
        color: #fff !important;
      }
      .inputData_table_searchable
        .Mui-TableHeadCell-Content-Actions.MuiBox-root.css-epvm6 {
        display: none !important;
      }
      // .inputData_table_searchable .css-i4bv87-MuiSvgIcon-root {
      //   font-size: 20px;
      // }
      .inputData_table_searchable .css-8k4lth {
        padding: 8px 0px;
      }
      // .inputData_table_searchable .css-1f2oslk-MuiTypography-root {
      //   font-size: 14px;
      // }
      .inputData_table_searchable
        .MuiSvgIcon-root[data-testid="CloseIcon"]  {
        font-size: 20px;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Clear search"] {
        color: rgb(196 192 192 / 54%);
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Toggle full screen"] {
        display: none;
      }
      .inputData_table_searchable .MuiIconButton-root[aria-label="Toggle density"] {
        display: none;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Show/Hide columns"] {
        display: none;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Show/Hide filters"] {
        display: none;
      }
      .inputData_table_searchable .MuiTableSortLabel-icon {
        display: none !important;
      }
      .inputData_table_searchable .css-nhjqqh-MuiTableContainer-root {
        max-height: 450px;
      }
      .inputData_table_searchable
        .MuiCollapse-root.MuiCollapse-horizontal.MuiCollapse-entered.css-1d98dbz-MuiCollapse-root {
        display: block !important;
      }
      .inputData_table_searchable
        .css-12yjm75-MuiInputBase-input-MuiOutlinedInput-input::placeholder {
        color: #fff !important;
      }
      .inputData_table_searchable {
        margin-top: 0px;
        min-width: 450px;
      }
      .inputData_table_searchable th {
        border-color: #f5f5f54d;
        background-color: #33383ccc;
        color: #fff;
        font-size: 15px;
        font-weight: 500;
        padding: 6px 10px;
        border: none;
      }
      .inputData_table_searchable td {
        border-color: #f5f5f54d;
        font-size: 14px;
        padding: 8px 8px;
        border: none;
        color: #fff;
      }
      .info-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        cursor: pointer;
    }
    
    .info-icon-container span {
        color: #000;
    }
    .inputData_table_searchable td:last-child span{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .inputData_table_searchable td:first-child{
        text-align:left;
    }
    .dataIndex_table .css-zrlv9q , .dataIndex_table .css-wsew38{
        justify-content: start;
    }
    .dataIndex_table .MuiFormControl-root-MuiTextField-root ,.dataIndex_table .MuiFormControl-root-MuiTextField-root {
        width:250px;
    }
    .inputData_table_searchable .css-euw4nl-MuiTableRow-root{
        background-color: #33383c !important;
    }
    .inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root{
        color: #fff !important;
    }
    .inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root.Mui-checked {
        color: #fff !important;
    }
    .inputData_table_searchable .css-1yq237c-MuiTableRow-root.Mui-selected {
        background-color: rgb(0 122 122) !important;
    }
    .inputData_table_searchable  .css-1yq237c-MuiTableRow-root td:after{
        background-color: transparent;
    }
    .inputData_table_searchable .selected-row {
        background-color: #e6f7ff; // Light blue as an example
      }
      .inputData_table_searchable .MuiTablePagination-root .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root {
        color: #36BDBE;
        // padding: 5px 0px;
      }
      .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to first page"],
      .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to previous page"],
      .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to next page"],
      .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to last page"] {
          color: rgba(255, 255, 255, 0.2) !important;
          border-radius: 6px;
          padding: 3px 3px;
      }

      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"],
      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"],
      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"],
      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] {
          color: #36BDBE !important;
          border-radius: 6px;
          padding: 3px 3px;
      }

      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"] svg,
      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"] svg,
      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"] svg,
      .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] svg {
          font-size: 27px !important;
      }
      .dataIndex_table .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 .MuiTablePagination-root .MuiTypography-root.MuiTypography-body2.MuiTypography-alignCenter{
        font-size: 14px;
      }
      .materialReactTableCustom{
        width: 500px;
        // transition: width 0.2s ease-out; 
      }
      .materialReactTableCustom.expand{
        width: 100%;
      }
      .table-container ant-tabs-tab-active{
        padding: 12px 20px 8px 20px !important;
      }
      .table-container nt-tabs-tab.ant-tabs-tab-active{
        color: #33383c !important;
      }
      .actionIconBox{
        gap: 10px !important;
        display: flex;
        min-width: 170px !important;
    }
    .inputData_table_searchable{
        border: none !important;
    }
    .custom-tabs .ant-tabs-tab {
        padding: 12px 25px 8px 25px;
        margin: 0 10px 0 0;
    }
    .custom-tabs .ant-tabs-tab-btn {
      color: #64666B; 
      font-size: 16px;
      font-weight: 600;
    } 
    .custom-tabs .ant-tabs-tab-btn:focus{
      color: #64666B; 
    }
    .custom-tabs .ant-tabs-tab-btn:hover{
      color: #36BDBE; 
    }
    .custom-tabs .ant-tabs-tab-btn:focus-visible{
      outline: none; 
    }
    .custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #36BDBE; 
    }
    
    .custom-tabs .ant-tabs-ink-bar {
        background-color: #36BDBE;
    }
    .custom-tabs > .ant-tabs-nav::before {
        border-color: #6A727C;
    }
    .project-details{
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .infoIcon svg{ 
      color: #ffffff;
      width: 15px;
    }
    .infoIcon:hover svg{
      color: #36BDBE;
    }
    .custom-select-dropdown .ant-select-selector {
        background: rgba(255, 255, 255, 0.24) !important;
        color: #ffffff;
        border: none !important;
    }
    
    .custom-select-dropdown .ant-select-arrow {
        color: #ffffff;
        font-size: 16px;
    }
    .custom-select-dropdown .ant-select-arrow .anticon >svg{
      height: 1.2rem !important;
    }
    .materialReactTableCustom .css-qpxlqp{
      left: 0;
      right: unset;
    }
    .custom-select-dropdown .ant-select-item {
        color: #ffffff; 
    }
    .custom-select-dropdown{
        min-width: 120px;
        height: 28px;
    }
    .custom-select-dropdown .ant-select-selection-item {
        color: #ffffff;
        padding-inline-end: 23px;
    }
    .table_checkbox_section .ant-checkbox .ant-checkbox-inner{
      background-color: transparent;
    }
    .materialReactTableCustom .MuiTablePagination-root .css-192dx0w span:nth-child(2){
      margin-right: 10px;
    }
    .button-name{
      background-color: transparent;
      color: #36BDBE;
      text-decoration: underline;
      cursor: pointer;
    } 
    .button-name:hover{
      background-color: transparent;
      color: #ffffff;
    } 
    .button-name:focus{
      outline: none;
    }
    .materialReactTableCustom .button-name-disabled{
      background-color: transparent;
      color: gray;
    }
    .dataIndex_table table th:last-child{
      position: sticky;
      right: 0;
      z-index: 99;
      background-color: #303336cc;
    }
    .dataIndex_table table td:last-child {
      position: sticky;
      right: 0;
      z-index: 99;
      background-color: #303336;
    }
    .dataIndex_table table td:last-child .css-1mwzkr2-MuiTypography-root{
      color: #ffffff;
      font-size: 14px;
      font-style: normal;
    }
    .materialReactTableCustom .css-wsew38{
      gap: 10px;
      padding: 0px;
    }
    .custom-tab-container{
      position: relative;
      min-width: 500px;
    }
    .tab-icons{
      position: absolute;
      display: flex;
      gap: 3px;
      top: 8px;
      right: 26px;
    }
    .tab-icons svg, .actionIconBox svg {
      transition: transform 0.2s ease-in-out; 
      cursor: pointer; /* Adjust timing and easing to your preference */
    }
    .tab-icons svg:hover, .actionIconBox svg:hover{
      transform: scale(1.2);
    }
    .inputData_table_searchable .materialReactTableCustom td{
      border-bottom: 1px solid #6A727C;
    }
    .inputData_table_searchable .materialReactTableCustom.expand td{
      border-bottom: 1px solid #6A727C;
    }


    .materialReactTableCustom .ant-checkbox-inner {
      background-color: transparent;
      border: 2px solid #ffffff;
    }
    .materialReactTableCustom .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #007a7a;
      border-color: #007a7a;
      border: 2px;
    }
  
    .materialReactTableCustom
      .ant-checkbox-indeterminate
      .ant-checkbox-inner:after {
      background-color: #007a7a;
    }
    .materialReactTableCustom span.ant-checkbox-inner:hover {
      border-color: #ffffff !important;
    }
    .loading_box .ant-spin-dot-item {
      background-color: #36BDBE; /* Change to your desired color */
    }
    .batch_btn{
      height: 28px;
      background-color: #36BDBE;
      border: none;
    }
    .batch_btn:disabled{
      opacity: 0.5;
      color: #ffffff !important;
    }
    .batch_btn:disabled:hover{
      opacity: 0.5;
    }
    .batch_btn:hover{
      height: 28px;
      background-color: #36BDBE !important;
      color: #ffffff !important;
      border: none;
    }
    .batch_btn:focus{
      outline: none;
      box-shadow: none;
    }
    .name_btn{
      display: flex;
      gap: 10px;
    }
    .infoIcon svg{
      color: #ffffff;
      width: 17px;
    }
    .infoIcon:hover svg{
      color: #36BDBE;
    }

    // batch detail page css
    .batch_info{
      padding: 10px 0px;
    }
    .batch_info p{
      display: block;
      margin: 0px;
      margin-bottom: 5px;
      color: #ffffff;
      font-size: 15px;
    }

    .batchCustomTable{
      width: 100%;
    }

    .batchCustomTable .css-zrlv9q {
      padding-left: 0px;
      gap: 0px;
  }

  .batchCustomTable .css-wsew38{
    gap: 0px;
    padding: 0px;
  }

  .inputData_table_searchable .batchCustomTable td{
    border-bottom: 1px solid #6A727C;
  }
  .table_batch_container{
    // margin: 10px 0px;
  }
  .table_batch_container .ant-tabs-content-holder{
    // height: calc(100vh - 120px) !important;
  }


  // create batch modal css
  .add_batch_block{
    padding-bottom: 15px;
  }
  .custom_batch_input{
    min-width: 200px;
    width: fit-content;
  }
  .custom_batch_input{
    background: rgba(255, 255, 255, 0.24) !important;
    color: #ffffff;
    border: none !important;
  }
  .custom_batch_input.ant-input-disabled{
    color: #bebebe;
    background: rgba(255, 255, 255, 0.5) !important;
  }

// conversation css
.conversation__inner__block{
    display: inline-block;
    padding: 20px 0px 25px 0px;
    width: 100%;
}
.conversation_left_block{
    width: 24%;
    float: left;
    padding-right: 20px;
    border-right: 1px solid #6A727C;
    max-height: 450px;
    overflow-y: auto;
}
.conversation_right_block{
    width: 76%;
    float: right;
    max-height: 450px;
    overflow-y: auto;
    padding-left: 20px;
}
.conversation_menu_btn{
    // min-width: 185px;
    // max-width: 185px;
    width: 100%;
    margin-bottom: 20px;
    background-color: #5C5E63;
    border-radius: 4px;
    color: #ffffff;
    border: none;
    height: auto;
    padding: 6px 10px;
    white-space: break-spaces;
    font-weight: 500;
    transition: background-color 0.5s ease, color 0.5s ease;
}
.conversation_menu_btn:hover{
    background-color: #36BDBE !important;
    color: #000000 !important;
}
.conversation_menu_btn:focus{
    outline: none;
    box-shadow: none;
}
.conversation_menu_btn span{
    font-size: 14px;
}
.footer_box{
  width: 100%;
}
.footer_inner_box{
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 12px;
  flex-wrap: wrap;
}
.footer_btn{
  min-width: 225px;
  max-width: 225px;
  margin-bottom: 20px;
  background-color: #36BDBE;
  border: 1px solid #36BDBE;
  border-radius: 4px;
  color: #000000;
  border: none;
  height: auto;
  padding: 10px 10px;
  font-weight: 500;
  transition: background-color 0.5s ease, color 0.5s ease, border 0.5s ease;
  letter-spacing: 0.5px;
  font-size: 13px;
  white-space: break-spaces;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.footer_btn:focus{
  outline: none;
  box-shadow: none;
}
.footer_btn_save:hover{
  background-color: transparent;
  color: #36BDBE !important;
}
.footer_btn_save:hover{
  background-color: transparent;
  color: #36BDBE !important;
  border: 1px solid #36BDBE !important;
}
.form_input_item{
  margin-bottom: 0px;
}
.project_input_column{
  min-height: 32px;
}

.footer_btn_cancel{
  background-color: #5C5E63;
  color: #ffffff;
  border: 1px solid #5C5E63;
  transition: background-color 0.5s ease, color 0.5s ease, border 0.5s ease;
}
.footer_btn_cancel:hover{
  background-color: transparent;
  border: 1px solid #ffffff !important;
  color: #000000 !important;
}
.footer_box{
  padding: 12px 0px 0px 0px;
}
.custom_conversation_tab_container .ant-tabs-content-holder{
  padding: 0px;
}
.custom_conversation_tab_container{
  min-width: 100%;
}
.form_block{
  padding: 20px 10px;
}
.form_block .ant-row{
  display: flex;
  align-items: center;
}
.form_block .project_input_row{
  margin-bottom: 20px;
}
.form_block label{
  color: #ffffff;
  font-size: 13px;
}
.form_block input{
  border-radius: 0px;
  padding: 5px 10px;
  background-color: #5C5E63;
  border: none;
  color: #ffffff;
  font-size: 13px;
}
.form_block .ant-select{
  background-color: #5C5E63;
  border: none;
  color: #ffffff;
  font-size: 13px;
}
.form_block .ant-select-selector{
  border-radius: 0px;
  background-color: #5C5E63;
  border: none;
  color: #ffffff;
  font-size: 13px;
}
.form_block .tag_column .ant-select-selection-item{
  border-radius: 14px;
  background-color: #000000;
  margin: 3px;
  padding-inline-end: 8px;
}
.form_block .ant-select-multiple .ant-select-selection-item-content{
  margin-inline-end: 8px;
}
.form_block .anticon.anticon-close{
  background-color: #36BDBE;
  border-radius: 50%;
  padding: 2px;
}
.form_block .anticon-close svg{
  font-size: 10px;
  width: 8px;
  height: 8px;
  color: #000000;
}
.form_block input::placeholder, .form_block .ant-select-selection-placeholder{
  color: #CBC8C8;
}
.form_block .ant-select .ant-select-arrow svg{
  width: 14px;
  height: 14px;
  color: #939598;
}
.conversation_menu_btn.selected{
  background-color: #36BDBE;
  color: #000000;
}
.conversation_right_block .ant-collapse, .conversation_right_block .ant-collapse-item{
  border: none;
  border-radius: 0px;
}
.conversation_right_block .ant-collapse-item{
  background-color: #232529;
  margin-bottom: 10px;
}
.conversation_right_block .ant-collapse-header{
  color: #ffffff;
  font-size: 14px;
}
.conversation_right_block .ant-collapse-content{
  color: #ffffff;
  background-color: #232529;
  border-top: 0px;
}
.conversation_right_block .ant-collapse-expand-icon svg{
  width: 12px;
  height: 12px;
  color: #939598;
}
.conversation_right_block .ant-collapse-content-box{
  color: #ffffff;
}
.panel_data_form input, .panel_data_form label{
  color: #ffffff;
  font-family: 'Open Sans';
  font-size: 13px;
}
.panel_data_form input, .panel_data_form .MuiSelect-select{
  padding: 14px 15px;
  height: auto;
  color: #ffffff;
  font-size: 13px;
}
.panel_data_form .MuiSelect-select{
  min-height: auto;
}
.panel_data_form fieldset{
  border-color: #ffffff !important;
}
.panel_data_form .MuiInputLabel-root{
  font-size: 16px;
}
.panel_data_form legend{
  max-width: 100%;
  width: fit-content;
}
.panel_data_form .MuiInputBase-root:hover fieldset {
  border-color: #36BDBE !important;
}
.panel_data_form .MuiInputBase-root .Mui-focused fieldset {
  border-color: #36BDBE !important;
}
.panel_row{
  margin-bottom: 25px;
}
.panel_row:last-child{
  margin-bottom: 0px;
}

// geometry switch css
.toggle-wrapper {
  position: relative;
  width: 11.25rem;
  height: 2.8125rem;
  font-family: sans-serif;
  font-size: 0.75rem;
  font-weight: 100;
}

.toggle {
  display: none;
}

.foux-toggle {
  position: relative;
  width: 11.25rem;
  height: 2.8125rem;
  border-radius: 3px;
  margin: 0;
  background-color: #36BDBE;
}
.foux-toggle:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 5.625rem;
  height: 2.8125rem;
  background-color: #5C5E63;
  z-index: 3;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.toggle:checked ~ .foux-toggle:before {
  border-color: #00a5b5;
  left: 5.625rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.toggle--label:after, .toggle--label:before {
  position: absolute;
  top: 0;
  bottom: 0;
  transition: opacity 0.05s;
}

.toggle--label {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
  line-height: 2.8125rem;
  cursor: pointer;
  z-index: 12;
  letter-spacing: 0.0625rem;
  font-weight: 400;
  font-size: 14px;
}
.toggle--label:before {
  content: "Yes";
  left: 25%;
  transform: translateX(-50%);
  color: white;
  opacity: 1;
}
.toggle--label:after {
  content: "No";
  position: absolute;
  right: 0;
  left: 75%;
  transform: translateX(-50%);
  color: white;
  opacity: 1;
}
.toggle:checked + .toggle--label:after {
  transition-duration: 0.05s;
}

.field_toggle_icon{
  font-size: 28px;
  color: #939598;
  cursor: pointer;
}
.minus_12_right {
  margin-right: -12px;
}
.field_toggle_icon.field_toggle_icon_disabled{
  color: #93959847;
  cursor: no-drop;
}
.expand_icon{
  width: 26px !important;
  height: 26px !important;
  color: #939598 !important;
  margin-right: -5px;
}
.cursor_drop input{
  cursor: no-drop;
}

.conversionName.ant-input-disabled{
  color: #959595;
}
.col_inner_box{
  display: flex;
  gap: 15px;
  align-items: center;
  color: #ffffff;
  height: 32px;
}
.lock_icon:hover svg{
  color: #36BDBE;
}
.projection_header_title_box{
  text-align: center;
  font-size: 14px;
}
.panel_projection_column .MuiFormControl-root{
  margin: 15px 0px;
}
.panel_projection_column .MuiFormControl-root:last-child{
  margin-bottom: 0px;
}
.panel_left_column{
  border-right: 1px solid #6A727C;
}


// message info css
.message-info{
  text-align: right;
  color: #fff0be;
  font-size: 14px;
  padding-bottom: 15px;
}

// source info css
.source_info_box{
  background-color: #232529;
  padding: 10px 15px;
  color: #ffffff;
}
.source_info_box .ant-row .ant_col div{
  font-size: 12px !important;
}
.source_info_box .ant-row{
  padding: 3px 0px !important;
  border-bottom: 1px solid #6A727C;
}
.source_info_box .ant-row:last-child{
  border-bottom: none;
}
.source_info_title{
  font-size: 18px !important;
  margin: 0px;
  margin-bottom: 12px;
  display: block;
}
.info_col_left div{
  font-weight: bold;
}
.modal-tab-reload{
  top: 14px;
  margin-right: 3px;
}
.panel_projection_main_row .MuiAutocomplete-endAdornment{
  display: none;
}
.panel_projection_main_row .MuiAutocomplete-root .MuiOutlinedInput-root{
  padding-right: 14px !important;
}
.panel_projection_main_row .MuiAutocomplete-root{
  margin-bottom: 10px;
}


    @media only screen and (max-width: 600px) {
        .inputData_table_searchable .css-14vyde3-MuiCollapse-wrapperInner {
            width: 150px; 
        }
    
        .inputData_table_searchable .css-11sh9fj-MuiFormControl-root-MuiTextField-root, .inputData_table_searchable .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
            width: 150px;
        }
        .form_block{
          width: 100%;
        }
      }
      @media only screen and (max-width: 850px) {
        .form_block{
          width: 100%;
        }
      }
      @media only screen and (max-width: 1400px) {
        .inputData_table_searchable .materialReactTableCustom.expand{
          width: 83vw;
        }
        .inputData_table_searchable .css-nhjqqh-MuiTableContainer-root{
          max-height: 400px;
        }
      }
`;